import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { CheckoutDetailDto, CheckoutDetailResp } from './checkout-detail.type';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class CheckoutDetail implements UseCase<CheckoutDetailDto, CheckoutDetailResp> {
    checkoutRepository = inject(CheckoutRepository);

    execute(params: CheckoutDetailDto): Observable<CheckoutDetailResp> {
        return this.checkoutRepository.GetCheckoutDetail(params);
    }
}